import type { State, MetricType, ChartDataPoint } from './types';

export type Mutation = {
  type: 'setMetrics';
  data: { type: MetricType; data: ChartDataPoint[] };
};

export function reducer(state: State, action: Mutation): State {
  switch (action.type) {
    case 'setMetrics':
      return setMetrics(state, action);

    default:
      return state;
  }
}

function setMetrics(state: State, action: Mutation): State {
  return {
    ...state,
    data: {
      ...state.data,
      [action.data.type]: action.data.data,
    },
  };
}
